<div class="wrapper" *ngIf="items && items.length >0 && (items[0].leftContent || items[0].rightContent)">
    <span [innerHtml]="items[0].leftContent | sanitizeHtml: 'HTML' "> </span>
    <span class="right-content" [innerHtml]="items[0].rightContent | sanitizeHtml: 'HTML' "> </span>
</div>